import { render, staticRenderFns } from "./Privacy_policy.vue?vue&type=template&id=2c1685d0&scoped=true&"
import script from "./Privacy_policy.vue?vue&type=script&lang=js&"
export * from "./Privacy_policy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy_policy.vue?vue&type=style&index=0&id=2c1685d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1685d0",
  null
  
)

export default component.exports